import { render, staticRenderFns } from "./TeachingPlan.vue?vue&type=template&id=1c681b9a&scoped=true&"
import script from "./TeachingPlan.vue?vue&type=script&lang=js&"
export * from "./TeachingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c681b9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
